import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type RightArrowProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function RightArrowIcon({
  className,
  pathClassName = "stroke-black",
  ...props
}: RightArrowProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M8.417 20l6.587-6.587a2.013 2.013 0 000-2.826L8.417 4"
        stroke="#000"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default RightArrowIcon;
